// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2knsZ","actionsCol":"EnrolledClinics_actionsCol__3ufyB"};